export default "__VITE_ASSET__D6Mx$SFa__"